<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
      <div class="flex items-center pt-6">
        <button @click="openAddModal" class="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md">Aggiungi visitatore</button>
      </div>
    </div>
    <div class="p-6 pb-0">
      <PageServerTable
        :headers="headers"
        :items="visitors"
        :items-per-page.sync="ipp"
        :items-per-page-options="ippo"
        :sort-by="sortby"
        :items-length="visitorsCount"
        :reload-fn="reload"
        :item-value="'id'"
        :page="page"
        show-current-page
      >
        <template #item.badge="{ item }">
          <span>{{ item.badge?.code }}</span>
        </template>
        <template #item.actions="{ item }">
          <button @click="openEditModal(item)" class="bg-yellow-500 text-white px-2 py-1 rounded-md mr-2">Modifica</button>
          <button @click="openDeleteModal(item)" class="bg-red-500 text-white px-2 py-1 rounded-md">Elimina</button>
        </template>
      </PageServerTable>
    </div>

    <!-- Modale per aggiungere/modificare -->
    <div v-if="showModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeModal">
      <div class="bg-white p-6 rounded-md w-full max-w-md" @mousedown.stop>
        <h2 class="text-xl mb-4">{{ isEditing ? 'Modifica' : 'Aggiungi' }} visitatore abituale</h2>
        <form @submit.prevent="isEditing ? update() : add()">
          <div class="mb-4">
            <label class="block text-gray-700">Nome</label>
            <input v-model="form.name" type="text" class="p93__input" required>
            <div v-if="form.errors.name" class="text-red-500 text-sm pt-2">{{ form.errors.name }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Email</label>
            <input v-model="form.email" type="text" class="p93__input">
            <div v-if="form.errors.email" class="text-red-500 text-sm pt-2">{{ form.errors.email }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Telefono</label>
            <input v-model="form.phone" type="text" class="p93__input">
            <div v-if="form.errors.phone" class="text-red-500 text-sm pt-2">{{ form.errors.phone }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Azienda</label>
            <input v-model="form.company" type="text" class="p93__input">
            <div v-if="form.errors.company" class="text-red-500 text-sm pt-2">{{ form.errors.company }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Badge</label>
            <v-select :options="filteredBadges" v-model="form.badge" :value="form.badge"></v-select>
          </div>
          <div class="mb-4 grid grid-cols-2">
              <div>
                <label class="block text-gray-700">Auto-approvazione visite</label>
                <label class="cursor-pointer">
                  <input type="checkbox" v-model="form.auto_approve" style="display:none" @change="form.auto_always = form.auto_approve"/>
                  <div class="relative w-10 h-5 bg-gray-300 rounded-full transition-colors duration-200"
                  :class="{ 'bg-green-500': form.auto_approve }">
                  <span
                      class="absolute left-0 top-0 h-5 w-5 bg-white rounded-full shadow transform transition-transform duration-200"
                      :class="{ 'translate-x-5': form.auto_approve }"></span>
                  </div>
                </label>
              </div>
              <div v-if="form.auto_approve">
                <label class="block text-gray-700">Tutto il giorno</label>
                <label class="cursor-pointer">
                  <input type="checkbox" v-model="form.auto_always" style="display:none"/>
                  <div class="relative w-10 h-5 bg-gray-300 rounded-full transition-colors duration-200"
                  :class="{ 'bg-green-500': form.auto_always }">
                  <span
                      class="absolute left-0 top-0 h-5 w-5 bg-white rounded-full shadow transform transition-transform duration-200"
                      :class="{ 'translate-x-5': form.auto_always }"></span>
                  </div>
                </label>
              </div>
          </div>
          <div class="mb-4" v-if="form.auto_approve && !form.auto_always">
            <label class="block text-gray-700">Range di ore</label>
            <VueDatePicker v-model="form.range1" range time-picker auto-apply/>
            <VueDatePicker v-model="form.range2" range time-picker auto-apply/>
          </div>
          <div class="flex justify-end">
            <button type="button" @click="closeModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
            <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded-md">{{ isEditing ? 'Aggiorna' : 'Aggiungi' }}</button>
          </div>
          <input type="hidden" v-model="form.id">
        </form>
      </div>
    </div>

    <!-- Modale di conferma eliminazione -->
    <div v-if="showDeleteModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @click="closeDeleteModal">
      <div class="bg-white p-6 rounded-md w-full max-w-md" @click.stop>
        <h2 class="text-xl mb-4">Conferma Eliminazione</h2>
        <p>Sei sicuro di voler eliminare visitatore {{ itemToDelete.name }}?</p>
        <div class="flex justify-end mt-4">
          <button @click="closeDeleteModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
          <button @click="deleteItem" class="bg-red-500 text-white px-4 py-2 rounded-md">Elimina</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, useForm, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Datepicker from 'vue3-datepicker';
import PageServerTable from '@/Components/PageServerTable.vue';
import 'vue-select/dist/vue-select.css';

export default {
  props: ['visitors', 'visitorsCount', 'badges', 'errors'],
  components: {
    Link,
    BreadCrumbs,
    Datepicker,
    PageServerTable
  },
  data() {
    return {
      headers: [],
      sortby: [],
      ipp: 5,
      ippo: [
        { value: 5, title: '5' },
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' }
      ],
      page: 1,
      filteredBadges: [],
      showModal: false,
      showDeleteModal: false,
      isEditing: false,
      form: useForm({
        id: null,
        name: '',
        email: '',
        phone: '',
        company: '',
        badge: null,
        selectedBadge: null,
        auto_approve: false,
        auto_always: false,
        range1: null,
        range2: null
      }),
      itemToDelete: null,
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.reception-digitale'), href: route('modules.home', 'reception-digitale') },
        { name: 'Visitatori abituali', href: route('modules.rd-gestione-visitatori') }
      ],
      dateFormat: 'yyyy-MM-dd',
    };
  },
  mounted() {
    this.headers = this.$attrs.headers;
    this.sortby = this.$attrs.sortby;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined) {
      if (sortby) this.sortby = sortby;
      if (itemsperpage) this.ipp = itemsperpage;
      if (page) this.page = page;
      router.post(window.location.href, {
        headers: this.headers,
        sortby: this.sortby,
        itemsperpage: this.ipp,
        page: this.page
      }, { only: ['visitors', 'visitorsCount'] });
    },
    openAddModal() {
      this.form.clearErrors();
      this.filteredBadges = this.badges.filter(badge => badge.visitor_id === null);
      this.form.id = null;
      this.form.name = '';
      this.form.email = '';
      this.form.phone = '';
      this.form.company = null;
      this.form.badge = null;
      this.isEditing = false;
      this.form.auto_approve = false;
      this.form.auto_always = false;
      this.form.range1 = null;
      this.form.range2 = null;
      this.showModal = true;
    },
    openEditModal(item) {
      this.filteredBadges = this.badges.filter(badge => badge.visitor_id === null || (badge.visitor_id !== null && badge.visitor_id === item.id));
      this.form.reset();
      this.form.badge = (item.badge) ? {
        id: item.badge.id,
        label: item.badge.code,
        visitor_id: item.badge.visitor_id
      } : null;
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.email = item.email;
      this.form.phone = item.phone;
      this.form.company = item.company;
      this.form.auto_approve = item.auto_approve;
      this.form.auto_always = item.auto_always;
      if (item.first_range_start && item.first_range_end)
      {
        this.form.range1 = [
          {
            hours: item.first_range_start.split(":")[0],
            minutes: item.first_range_start.split(":")[1]
          },
          {
            hours: item.first_range_end.split(":")[0],
            minutes: item.first_range_end.split(":")[1]
          }
        ]
      }
      if (item.second_range_start && item.second_range_end)
      {
        this.form.range2 = [
          {
            hours: item.second_range_start.split(":")[0],
            minutes: item.second_range_start.split(":")[1]
          },
          {
            hours: item.second_range_end.split(":")[0],
            minutes: item.second_range_end.split(":")[1]
          }
        ]
      }
      this.isEditing = true;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    add() {
      this.form.post(route('modules.rd-aggiungi-visitatore'), {
        onSuccess: () => this.closeModal()
      });
    },
    update() {
      this.form.post(route('modules.rd-modifica-visitatore'), {
        onSuccess: () => this.closeModal()
      });
    },
    openDeleteModal(item) {
      this.itemToDelete = item;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    deleteItem() {
      this.form.delete(route('modules.rd-elimina-visitatore', this.itemToDelete.id), {
        onSuccess: () => this.closeDeleteModal()
      });
    }
  }
};
</script>